"use client";

import CoverageCard from "@/src/components/cards/coverage-card/coverage-card";
import PatientCard from "@/src/components/cards/patient-card/patient-card";
import ReferralCard from "@/src/components/cards/referral-card/referral-card";
import { CopyableContent } from "@/src/components/copyable-content";
import { EhrInstructionsCard } from "@/src/components/ehr-instructions-card";
import { ReferralProviderCards } from "@/src/components/tasks/referral-provider-cards";
import { formatDateForFilename } from "@/src/lib/utils/date-and-phone-utils";
import { Referral } from "@/src/models/documents/referral";

interface TexasHeartSouthHeartReferralInstructionsProps {
  referral: Referral;
  schedulerName: string;
}

export function TexasHeartSouthHeartReferralInstructions({
  referral,
  schedulerName,
}: TexasHeartSouthHeartReferralInstructionsProps) {
  const formattedDateOfReferral = formatDateForFilename(referral.dateOfReferral);

  return (
    <div className="flex flex-col gap-8 w-full sm:min-w-[800px] max-w-[1200px] mx-auto">
      <EhrInstructionsCard>
        <div className="text-sm text-muted-foreground">
          <div className="flex flex-col gap-2">
            <span className="font-medium mb-4">South Heart Referral Instructions:</span>
            <div className="text-muted-foreground">
              <p>1. Create or Update the patient in eCW</p>
              <p>
                2. Upload the file in Patient Docs, under the Referrals folder. Name the file{" "}
                <CopyableContent text={`${formattedDateOfReferral} Referral`} />
              </p>
              <p>
                Assign to <CopyableContent text={schedulerName} />
              </p>
            </div>
          </div>
        </div>
      </EhrInstructionsCard>

      <PatientCard patient={referral.patient} />
      <ReferralProviderCards referral={referral} />
      <ReferralCard referral={referral} isEditable />
      {referral.primaryCoverage && <CoverageCard coverage={referral.primaryCoverage!} type="Primary" isEditable />}
      {referral.secondaryCoverage && (
        <CoverageCard coverage={referral.secondaryCoverage!} type="Secondary" isEditable />
      )}
    </div>
  );
}
